import enApp from './en-US/app.json'
import enCampaign from './en-US/campaign.json'
import enCountries from './en-US/countries.json'
import enCurrencies from './en-US/currencies.json'
import enPersonTitle from './en-US/personTitle.json'
import zhApp from './zh-CN/app.json'
import zhCampaign from './zh-CN/campaign.json'
import zhCountries from './zh-CN/countries.json';
import zhCurrencies from './zh-CN/currencies.json';
import zhPersonTitle from './zh-CN/personTitle.json';

import zhTWApp from './zh-TW/app.json'
import zhTWCountries from './zh-TW/countries.json';
import zhTWCurrencies from './zh-TW/currencies.json';
import zhTWPersonTitle from './zh-TW/personTitle.json';

import jpJPApp from './jp-JP/app.json'
import jpJPCountries from './jp-JP/countries.json';
import jpJPCurrencies from './jp-JP/currencies.json';
import jpJPPersonTitle from './jp-JP/personTitle.json';

import koKRApp from './ko-KR/app.json'
import koKRCountries from './ko-KR/countries.json';
import koKRCurrencies from './ko-KR/currencies.json';
import koKRPersonTitle from './ko-KR/personTitle.json';
export default {
    'en-US': {
        app: { ...enApp, ...enCampaign },
        countries: enCountries,
        currencies: enCurrencies,
        personTitle: enPersonTitle,
    },
    'zh-CN': {
        app: { ...zhApp, ...zhCampaign },
        countries: zhCountries,
        currencies: zhCurrencies,
        personTitle: zhPersonTitle,
    },
    'zh-TW': {
        app: zhTWApp,
        countries: zhTWCountries,
        currencies: zhTWCurrencies,
        personTitle: zhTWPersonTitle,
    },
    'jp-JP': {
        app: jpJPApp,
        countries: jpJPCountries,
        currencies: jpJPCurrencies,
        personTitle: jpJPPersonTitle,
    },
    'ko-KR': {
        app: koKRApp,
        countries: koKRCountries,
        currencies: koKRCurrencies,
        personTitle: koKRPersonTitle,
    },
};
